import { routes } from '@/config/routes';
import colors from '@/constants/colors';
import { withTranslation } from '@/i18n';
import { LinkWithi18n } from '@/infra/link/withi18n';
import styles from '@/interface/ui/404/index.module.scss';
import Layout from '@/interface/ui/_shared/layout/index';
import type { RootState } from '@/store/index';
import type { NextPage } from 'next';
import Head from 'next/head';
import React from 'react';
import { useSelector } from 'react-redux';

const meta = {
  title: 'atmos LISTs',
  description: 'atmos LISTs',
};

const E404: NextPage = () => {
  const { country, language } = useSelector((state: RootState) => state.app);

  return (
    <>
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} key="title" />
      </Head>
      <Layout style={{ backgroundColor: colors.white }}>
        <div className={styles.container}>
          <img src="/static/images/atmos.png" alt="atmosLogo" />

          <p className={styles.title}>ご指定のページが見つかりませんでした</p>
          <p className={styles.description}>申し訳ございませんが</p>
          <p className={styles.description}>
            「ホームへ戻る」ボタンよりお進みください。
          </p>
          <button type="button" className={styles.button}>
            <LinkWithi18n
              to={routes.index}
              country={country}
              language={language}
            >
              <a className={styles.a}>ホームに戻る</a>
            </LinkWithi18n>
          </button>
        </div>
      </Layout>
    </>
  );
};

// @see https://github.com/vercel/next.js/blob/master/errors/404-get-initial-props.md
// E404.getInitialProps = async ({ req }) => {
//   const namespacesRequired = ['common'];
//   const isClient = req === undefined;
//   if (isClient) {
//     return {};
//   }

//   return {
//     namespacesRequired,
//   };
// };

export default withTranslation('common')(E404);
